module.exports = __webpack_public_path__ + "img/pick5.31545e39.png";